import DocumentationButton from "components/DocumentationButton";
import {
  EmptystateModulesColored,
  EmptystateSearchNoResultsColored,
} from "components/icons/generated";
import Box from "ds/components/Box";
import LinkButton from "ds/components/Button/LinkButton";
import EmptyState from "ds/components/EmptyState";
import useTypedContext from "hooks/useTypedContext";
import { getDocsUrl } from "utils/getDocsUrl";
import { AccountContext } from "views/AccountWrapper";

type ModulesEmptyStateProps = {
  didPerformSearch?: boolean;
};

const ModulesEmptyState = ({ didPerformSearch }: ModulesEmptyStateProps) => {
  const { viewer } = useTypedContext(AccountContext);

  return (
    <Box align="center" justify="center" grow="1">
      {didPerformSearch && (
        <EmptyState
          title="No results"
          icon={EmptystateSearchNoResultsColored}
          caption="Don’t give up! Check the spelling or try something less specific."
          announce
        />
      )}
      {!didPerformSearch && viewer.admin && (
        <EmptyState title="You don’t have any modules yet" icon={EmptystateModulesColored}>
          <Box gap="medium">
            <DocumentationButton
              to={getDocsUrl("/vendors/terraform/module-registry.html")}
              label="Documentation"
            />
            <LinkButton variant="primary" to="/new/module">
              Create module
            </LinkButton>
          </Box>
        </EmptyState>
      )}
      {!didPerformSearch && !viewer.admin && (
        <EmptyState
          title="Spacelift is no fun without modules and you don't have access to any yet"
          icon={EmptystateModulesColored}
          caption="Please reach out to one of your friendly account admins to grant you access, or create a
        new module for you to play with."
        />
      )}
    </Box>
  );
};

export default ModulesEmptyState;
